import React, { Component } from 'react';

import {Card, CardHeader, CardContent } from '@material-ui/core';

import Typography from '@material-ui/core/Typography';
import {List, ListItem, ListItemText } from '@material-ui/core';

import { withStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';

import { CustomizedPlanPrice } from '../Prices';
import CheckCircle from '@material-ui/icons/CheckCircle';
import ResourceIcon from '../resources/ResourceIcon';
import { FormattedNumber, FormattedPlural, FormattedMessage } from 'react-intl';
import ResourceLabel from '../resources/ResourceLabel';
import ResourceValue from '../resources/ResourceValue';
import { Domain } from '@material-ui/icons';

/**
 * Plan View, displaying description and features (resource) for a plan
 * visible when creating a subscription (plan picker)
 */

const styles = theme => ({
  card: theme.card,
  form: theme.form,
  icon: {
    color: "#ddd"
  },
  header: {
    backgroundColor: theme.palette.primary.main,
  },
  headerContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  spacing: {
    marginTop:12, 
    marginBottom:12,
  },
  trial: {
    minWidth: 90
  },
  price: {
    fontWeight: 'bold',
    textAlign: 'right',
  },
  chip: {
    color: '#447418',
  },
  cardHeader: {
    minHeight: 92
  },
  cardContent: {
    minHeight: 233,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  empty: {
    height: 54,
  },
  divider: {
    backgroundColor: '#3E82F7',
    width: 40,
    height: 2, 
    margin: 'auto'
  },
})


class PlanCard extends Component {

  render() {
    const {
      plan,
      classes,
      actions,
      checked,
    } = this.props;

    const isPlanWithDomainInvitationsSettings = !!plan.domainInvitationSettings;
    const maxDomainsCount = isPlanWithDomainInvitationsSettings? plan.domainInvitationSettings.maxDomainsCount : 0;

    return (
      <Card className={classes.card}>
        <CardHeader
          className={classes.cardHeader}
          title={
            <span>
              {checked && <CheckCircle style={{ float: "right" }} color="primary" />}
              <div className={classes.headerContent}>
                <Typography variant='h6'>{plan.name}</Typography>
                <Typography variant='subtitle1'> 
                  <CustomizedPlanPrice plan={plan}  />
                </Typography>
              </div>
            </span>
          }
        />
        <Divider variant="middle" className={classes.divider} />
        <CardContent className={classes.cardContent}>
          <Typography component="p" className={classes.spacing} >{plan.description}</Typography>
          {plan.resources && (
            <List dense>
              {plan.resources.map(resource => (
                <ListItem key={resource.id}>
                  <ResourceIcon color="primary" resource={resource} />
                  <ListItemText
                    primary={
                      <ResourceValue
                        resource={resource}
                        displayUnit
                        displayLimit />
                    }
                    secondary={
                      <span>
                        <ResourceLabel
                          resource={resource} />
                        {" / "}
                        <ResourceLabel
                          resource={{ id: 'licence' }} />
                      </span>
                    }
                  />
                </ListItem>
              ))}
              {isPlanWithDomainInvitationsSettings ?
                <ListItem key={"resource.id"}>
                    <Domain color="primary"/>
                    <ListItemText
                      primary={
                        <FormattedMessage id={'domain.plan.label.title'} />
                      }
                      secondary={
                        <span>
                          <FormattedNumber value={maxDomainsCount} />
                          {" "}
                          <FormattedPlural
                            value={maxDomainsCount}
                            one={
                              <FormattedMessage id={'domain.plan.label.description'} />
                            }
                            other={
                              <FormattedMessage id={'domain.plan.label.description.plural'} />
                            }
                          />
                        </span>
                      }
                    />
                </ListItem>
                :
                <ListItem key={"emptyItem"} className={classes.empty} />
              }
            </List>
          )}
        </CardContent>
        {actions}
      </Card>
    );
  }
}


export default withStyles(styles)(PlanCard);


// WEBPACK FOOTER //
// ./src/components/plans/PlanCard.js